<form [formGroup]="targetForm">
    <section class="sideRight-body">
  
     
  
      <div id="container">
        <div id="contentC">
  
         
  
          <label for="entityname">
  
            <i class="fas fa-asterisk"></i> <b> Entity Name</b>
            <span *ngIf="f.legalEntityName.errors && (f.legalEntityName.touched || f.legalEntityName.dirty)">
              <span class="required-error" *ngIf="f.legalEntityName.errors.required">(required)</span>
          </span>
            <input class="black-input opposite-colors" type="text"  no-special-chars="#!$%^<>+='"
            (keyup)="checkEntityName()"
            (input)="valueChanged();checkInput()"
            placeholder="Entity Name"
              (blur)="trimSpecialChar('legalEntityName');" formControlName="legalEntityName" maxlength="100">
              
          </label>
        </div>
      </div>
      <div class="form-error-sign error-message" *ngIf="entitynameNoError">
        <p>Entity Name is already in use.</p>
    </div>
      
  
      <div id="container">
        <div id="contentC">
          <label for="ein">
            <b>EIN</b>
            <input class="black-input opposite-colors" (input)="checkInput()" no-special-chars="#!$%^<>+='"
            maxlength="20" placeholder="EIN" formControlName="ein">
          </label>
        </div>
      </div>
  
      <div id="container">
        <div id="contentC">
          <label for="businessactivitycode">
            <b> Business Activity Code</b>
            <div class="input-icon-right">
              <input class="black-input opposite-colors" (input)="checkInput()" placeholder="Business Activity Code" type="text"
              maxlength="20" no-special-chars="#!$%^<>+='" formControlName="businessactivitycode">
              
            </div>
          </label>
        </div>
      </div>
  
    </section>
    <footer class="endFormSubmit info-tile">
      <button type='button' (click)="editEntity()" class="btn btn-success" 
      [disabled]="(!targetForm.valid || isDisabled) || entitynameNoError || !isEntityValueEntered || !valchanged"
        >Save Changes</button> &nbsp;
      <button class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
    </footer>
  </form>